import React from 'react';

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="space-y-2">
    <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
    <div className="text-gray-600 leading-relaxed">{children}</div>
  </div>
);

const TermsPage: React.FC = () => (
  <div className="min-h-screen bg-[#FCFCFC] py-12 px-4 md:px-20">
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Terms and Conditions</h1>
      <p className="text-gray-400 text-sm mb-8">Last updated: August 2026</p>
      <div className="bg-white rounded-xl shadow p-8 space-y-6">
        <Section title="1. Acceptance of Terms">
          <p>Sasta Fashions is a brand owned and operated by <span className="font-semibold text-gray-800">SASTA DEAL PRIVATE LIMITED</span>. By accessing or using Sasta Fashions, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our platform.</p>
        </Section>
        <Section title="2. Use of the Platform">
          <p>You agree to use this platform only for lawful purposes. You must not misuse the platform in any way that is harmful or violates applicable laws.</p>
        </Section>
        <Section title="3. Account Responsibility">
          <p>You are responsible for maintaining the confidentiality of your account credentials. Any activity under your account is your responsibility.</p>
        </Section>
        <Section title="4. Product Information">
          <p>We make every effort to display product details accurately. However, colors may vary slightly due to screen settings. We reserve the right to modify pricing without prior notice.</p>
        </Section>
        <Section title="5. Intellectual Property">
          <p>All content on this platform including images, logos, and text is the property of SASTA DEAL PRIVATE LIMITED. Unauthorized use is prohibited.</p>
        </Section>
        <Section title="6. Limitation of Liability">
          <p>SASTA DEAL PRIVATE LIMITED is not liable for any indirect or consequential losses arising from the use of this platform.</p>
        </Section>
        <Section title="7. Governing Law">
          <p>These terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts in West Bengal.</p>
        </Section>
        <Section title="8. Contact Us">
          <p>For any queries, reach us at <span className="text-[#DAA520]">sastadealpvt@gmail.com</span></p>
        </Section>
      </div>
    </div>
  </div>
);

export default TermsPage;
